import { ACCOUNT_LOGIN_REQUEST_FAIL, ACCOUNT_LOGIN_REQUEST_SUCCESS, ACCOUNT_LOAD, LOGOUT_ACCOUNT, UPDATE_PROFILE } from '../action.types'

import initialState from '../initial.state'
import SwitchCase from '../../shared/functions/SwitchCase'
import {appInsights} from "../../shared/services/AppInsightsService";

const buildResponse = (action, state) => {
  if (action.type === ACCOUNT_LOGIN_REQUEST_SUCCESS) {
    const payload = action.payload;
    const profile = {
      id: payload.id,
      email: payload.email,
      name: payload.nome,
      photo: payload.foto,
      role: payload.perfil,
      userId: payload.idUsuario
    }

    localStorage.setItem(process.env.REACT_APP_AUTH_TOKEN, payload.token)
    localStorage.setItem(process.env.REACT_APP_REFRESH_TOKEN, payload.refreshToken)
    localStorage.setItem(process.env.REACT_APP_PROFILE, JSON.stringify(profile))

    appInsights.setAuthenticatedUserContext(profile.id, profile.email, false)

    return profile;
  }
  return state;
}

const updateProfile = (action, state) => {
  if (action.type === UPDATE_PROFILE) {
    const payload = action.account;
    const profile = {
      id: state.id,
      email: payload.email,
      name: payload.fantasyName || payload.name,
      photo: payload.photo || payload.photoUrl,
      role: state.role,
      userId: state.userId,
    }
    localStorage.setItem(process.env.REACT_APP_PROFILE, JSON.stringify(profile))
    return profile
  }
  return state;
}

export default (state = initialState.account, action) =>
  SwitchCase({
    [ACCOUNT_LOGIN_REQUEST_SUCCESS]: { ...buildResponse(action, state) },
    [ACCOUNT_LOAD]: { ...action.account },
    [LOGOUT_ACCOUNT]: {},
    [UPDATE_PROFILE]: { ...updateProfile(action, state) },
    [ACCOUNT_LOGIN_REQUEST_FAIL]: state
  })(state)(action.type)
